import React from 'react';
import './BookForm.css'
import FormInput from '../Common/FormInput';
import Btn from '../Common/Btn';

const BookForm = () => {
    return ( 
        <form action="">
            <FormInput FormInputLabel='Select Event' FormInputPlaceholder='' FormInputType='text'/>

            <div className='FormGrid'>
        
                <FormInput FormInputLabel='Event Date' FormInputPlaceholder='' FormInputType='date'/>
                <FormInput FormInputLabel='Number of Tickets' FormInputPlaceholder='0' FormInputType='Number'/>
                <FormInput FormInputLabel='First Name' FormInputPlaceholder='Enter your first name' FormInputType='text'/>
                <FormInput FormInputLabel='Last Name' FormInputPlaceholder='Enter your last name' FormInputType='text'/>
                <FormInput FormInputLabel='Email Address' FormInputPlaceholder='your.email@example.com' FormInputType='email'/>
                <FormInput FormInputLabel='Phone Number' FormInputPlaceholder='+20 123 456 7890' FormInputType='tel'/>
            </div>

            <Btn BtnText='Complete Booking' BtnStyle='PinkBtn'/>

            <p className='FormSub'>Your tickets will be sent to your email immediately after booking</p>
        </form>
     );
}
 
export default BookForm;